import { render } from "./com_formato1.vue?vue&type=template&id=48bb4f61&scoped=true"
import script from "./com_formato1.vue?vue&type=script&lang=js"
export * from "./com_formato1.vue?vue&type=script&lang=js"

import "./com_formato1.vue?vue&type=style&index=0&id=48bb4f61&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bb4f61"]])

export default __exports__